import { useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/" replace />;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr(await login(email, password));
    setBusy(false);
  };
  return (
    <div className="grain flex min-h-screen items-center justify-center bg-[#0B0F19] px-4">
      <form onSubmit={submit} className="panel w-full max-w-sm p-8 fade-up" data-testid="login-form">
        <div className="font-display text-2xl font-bold text-slate-50">SRM<span className="text-amber-500">.</span>Group</div>
        <div className="mt-1 text-xs tracking-[0.2em] text-slate-400" data-testid="login-tagline">Management Dashboard</div>
        <div className="mt-8 space-y-3">
          <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="border-slate-700 bg-slate-900/70" data-testid="login-email-input" />
          <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className="border-slate-700 bg-slate-900/70" data-testid="login-password-input" />
          {err && <div className="text-sm text-rose-400" data-testid="login-error">{err}</div>}
          <Button type="submit" disabled={busy} className="w-full bg-amber-500 text-slate-950 hover:bg-amber-400" data-testid="login-submit-button">
            {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Sign in
          </Button>
        </div>
        <p className="mt-6 text-[11px] text-slate-500">Accounts are created by the administrator. Contact your administrator for access.</p>
      </form>
    </div>
  );
}
